import { useModalContext } from '@/contexts/ModalContext';
import { useAuthStore } from '@/stores/authStore';
import { isLivenessVerified } from '@/utils/isVerified';
import { isBorrower, isInvestor } from '@/utils/user';

export const UserValidationInfoSection = () => {
  const { user } = useAuthStore();
  const { openUserVerificationModal } = useModalContext();

  if (!user) {
    return null;
  }

  const livenessVerified = isLivenessVerified(user);
  const isVerifiedInvestor = isInvestor(user) && user.has_invitation_code;

  if (livenessVerified && (isVerifiedInvestor || isBorrower(user))) {
    return null;
  }

  return (
    <div className="w-full bg-[#FDE59D] py-4 mb-10 -mt-2 flex flex-col items-center justify-center font-avenir">
      <div className="w-full flex flex-row items-center justify-between px-16 md:px-32 lg:px-56">
        <div className="text-black text-sm font-medium text-center italic">
          {isBorrower(user) && 'To be able to create a pool you need to first verify your account'}
          {isInvestor(user) && 'To explore pools and invest '}
        </div>
        <button
          className="underline text-black text-sm font-medium cursor-pointer px-2 py-1 rounded hover:bg-[#fbe6a8] transition whitespace-nowrap"
          type="button"
          onClick={openUserVerificationModal}
        >
          Verify your account →
        </button>
      </div>
    </div>
  );
};
